import React from 'react'

interface IRepreInfoProps {
  href?: string
  label: string
  linkText?: string
  rf?: string
}

const RepreInfo = ({ label, href, linkText, rf }: IRepreInfoProps) => (
  <div className='csas-center csas-pb-md csas-pt-sm csas-text--grey' data-testid='repre-info'>
    {label}
    {linkText && href && (
      <a data-testid={rf} href={href}>
        {linkText}
      </a>
    )}
  </div>
)

export default RepreInfo
